import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import Navigator from './components/Navigation';
import { Waiting } from './components/Waiting';
import './font.css';
import './style.css';
import { Footer } from './components/Footer';
import LifeTodoToggle from './components/LifeTodoToggle';
import NextItem from './components/NextItem';
import ActivitiyCard from './components/ActivitiesCard';
import thumbnail9 from './image/workThumbnails/thumbnail9.webp';
import BlogContent from './components/BlogContent';
import { Divider } from '@mui/material';
import article1MainImage from './image/articles/article1.webp';
import article2MainImage from './image/articles/article2_1.webp';
import article3MainImage from './image/articles/article3-1.webp';
import creative1Thumbnail from './image/articles/adblock.webp';
import creative2Thumbnail from './image/articles/article5-1.webp';
import creative3Thumbnail from './image/articles/creative3-1.webp';
import article5MainImage from './image/articles/article5.webp';
import article4MainImage from './image/articles/article4-1.webp';
import article6MainImage from './image/articles/article6.webp';
import essay2601Thumbnail from './image/articles/essay26012.webp';
import essay2602Thumbnail from './image/articles/essay26021.webp';
import essay2603Thumbnail from './image/articles/essay20260301.webp';
import essay2604Thumbnail from './image/articles/essay260401.webp';
import essay2605Thumbnail from './image/articles/essay260501.jpeg';
import essayHiroshimaThumbnail from './image/articles/히로시마/거리1.webp';
import ActivitiesChipFilter from './components/ActivitiesChipFilter';
import { useMetaTags } from './utils/useMetaTags';
import { useSearchParams } from 'react-router-dom';
import { isWithinNewBadgeWindow, parseActivityDisplayDateToIso } from './utils/newBadge';

type ActivityContentItem = {
  id: number;
  blogPage: string;
  title: string;
  titleEn?: string;
  description: string;
  descriptionEn?: string;
  category: string;
  categoryEn?: string;
  date: string;
  thumbnail?: string;
  locked: boolean;
  year: string;
  /** New 뱃지 기준일 YYYY-MM-DD. 없으면 `date`(YYYY.MM.DD.)에서 파싱 (공개 후 28일 이내면 New) */
  publishedAt?: string;
};

function getActivityShowNewBadge(item: ActivityContentItem): boolean {
  const launchIso = item.publishedAt ?? parseActivityDisplayDateToIso(item.date);
  return launchIso ? isWithinNewBadgeWindow(launchIso) : false;
}

function Activities(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'Activities - Lynkim',
      description: 'Activities and Articles by Product Designer Lynkim',
      image: '/ogimage.png',
    });
  
  const [searchParams, setSearchParams] = useSearchParams();
  
  // 필터 이름과 번호 매핑
  const filterMap: { [key: string]: number } = {
    'All': 1,
    'Creative': 2,
    'Book Report': 3,
    'Essay': 4,
    '2026': 5,
    '2025': 6,
    '2024': 7
  };

  const filterNameMap: { [key: number]: string } = {
    1: 'All',
    2: 'Creative',
    3: 'Book Report',
    4: 'Essay',
    5: '2026',
    6: '2025',
    7: '2024'
  };

  // URL 쿼리 파라미터에서 필터 읽기
  const getFilterFromURL = () => {
    const filterParam = searchParams.get('filter');
    if (filterParam && filterMap[filterParam] !== undefined) {
      return filterMap[filterParam];
    }
    return 1; // 기본값: All
  };

  const [activeFilter, setActiveFilter] = useState(getFilterFromURL());

  useEffect(() => {
    const newFilter = getFilterFromURL();
    setActiveFilter(newFilter);
  }, [searchParams]);

  // 필터 변경 핸들러
  const handleFilterChange = (value: SetStateAction<number>) => {
    const filterNumber = typeof value === 'function' ? value(activeFilter) : value;
    setActiveFilter(filterNumber);
    const filterName = filterNameMap[filterNumber];
    if (filterName) {
      setSearchParams({ filter: filterName });
    }
  };

  // 필터링 로직
  const getFilteredContent = (): ActivityContentItem[] => {
    const allContent: ActivityContentItem[] = [
     
      {
        id: 19,
        blogPage: "/Essay2606",
        title: "26.06. 회고",
        titleEn: "26.06. Review",
        description: "Let's pretend we had one / 새로운 루틴 / 나르시시즘적 욕구",
        category: "essay",
        date: "2026.06.28.",
        // thumbnail: essay2606,
        locked: false,
        year: "2026"
      },
      {
        id: 18,
        blogPage: "/Essay_hiroshima",
        title: "히로시마 여행기록",
        titleEn: "Travel Journal of Horishima",
        description: "히로시마에 두고온 것",
        descriptionEn: "Things I brought back from Hiroshima",
        category: "essay",
        date: "2026.06.12.",
        thumbnail: essayHiroshimaThumbnail,
        locked: false,
        year: "2026"
      },
      {
        id: 17,
        blogPage: "/Essay2605",
        title: "26.05. 회고",
        titleEn: "26.05. Review",
        description: "타투의 의미 / 새 회사 적응기",
        descriptionEn: "What My Tattoo Means / Settling into a New Company",
        category: "essay",
        date: "2026.05.25.",
        thumbnail: essay2605Thumbnail,
        locked: false,
        year: "2026"
      },
      // {
      //   id: 16,
      //   blogPage: "/Essay2600",
      //   title: "기록",
      //   description: "",
      //   category: "essay",
      //   date: "2026.05.12.",
      //   // thumbnail: essay2604Thumbnail,
      //   locked: true,
      //   year: "2026"
      // },
      {
        id: 15,
        blogPage: "/Essay2604",
        title: "26.04. 회고",
        titleEn: "26.04. Review",
        description: "춘유록색 / 감사함은 넘침이 없다 / 모든걸 잃더라도 지켜야 하는 것",
        descriptionEn: "Chunyurok, the color of spring buds / Gratitude can't be overdone / What I must keep even if I lose everything else",
        category: "essay",
        date: "2026.04.23.",
        thumbnail: essay2604Thumbnail,
        locked: true,
        year: "2026"
      },
      {
        id: 14,
        blogPage: "/Essay2603",
        title: "26.03. 회고",
        titleEn: "26.03. Review",
        description: "상실 / 이직 / 피겨스케이팅 / 보드게임 제작",
        descriptionEn: "Loss / Changing jobs / Figure skating / Making a board game",
        category: "essay",
        date: "2026.03.22.",
        thumbnail: essay2603Thumbnail,
        locked: true,
        year: "2026",
      },
      {
        id: 13,
        blogPage: "/Essay2602",
        title: "26.02. 회고",
        titleEn: "26.02. Review",
        description: "안될 이유보다 될 이유를 찾아야 한다 / 깊이있게 생각하는 것의 가치 / 디자이너 커리어와 디자인 리뷰에 대한 생각",
        descriptionEn: "Find reasons it can work, not reasons it cannot / The value of thinking deeply / Thoughts on a designer's career and design review",
        category: "essay",
        date: "2026.02.15.",
        thumbnail: essay2602Thumbnail,
        locked: true,
        year: "2026"
      },
      {
        id: 11,
        blogPage: "/book1",
        title: "롤스의 정의론",
        titleEn: "Rawls's Theory of Justice",
        description: "평등주의적 개인주의 관점의 정의론",
        descriptionEn: "A theory of justice from an egalitarian individualist perspective",
        category: "book report",
        date: "2026.02.01.",
        locked: false,
        year: "2026"
      },
        {
        id: 10,
        blogPage: "/Essay2601",
        title: "26.01. 회고",
        titleEn: "26.01. Review",
        description: "액땜이라고 하자 / 롤스의 정의론",
        descriptionEn: "Let's just call it bad luck burned off / Rawls's Theory of Justice",
        category: "essay",
        date: "2026.02.01.",
        thumbnail: essay2601Thumbnail,
        locked: true,
        year: "2026"
      },
      {
        id: 9,
        blogPage: "/Article6",
        title: "2025년 회고",
        titleEn: "2025 Year in Review",
        description: "2025년을 한 마디로 정의하자면 / 2026년의 나",
        descriptionEn: "Defining 2025 in one phrase / Who I want to be in 2026",
        category: "essay",
        date: "2025.01.18.",
        thumbnail: article6MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 8,
        blogPage: "/creative3",
        title: "2025 연말 게임 파티",
        titleEn: "2025 End-of-year Game Party",
        description: "서바이벌 게임 | 루시퍼 이펙트",
        descriptionEn: "Survival game | The Lucifer Effect",
        category: "creative",
        date: "2025.12.19.",
        thumbnail: creative3Thumbnail,
        locked: false,
        year: "2025"
      },
      {
        id: 7,
        blogPage: "/Article5",
        title: "25.11. 회고",
        titleEn: "25.11. Review",
        description: "사계절 만끽하기 / PM을 맡아 외부협력사와 함께 잘 일하기 / 거절을 못하는건 사실 이기적인 마음이다",
        descriptionEn: "Savoring all four seasons / Taking the PM role and working well with external partners / Not being able to say no is actually a selfish impulse",
        category: "essay",
        date: "2025.12.01.",
        thumbnail: article5MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 5,
        blogPage: "/Article4",
        title: "25.10. 회고",
        titleEn: "25.10. Review",
        description: "Life's lines of closeness / 몰입하는 시간  /  일의 태도 / 당근 4주년",
        descriptionEn: "Life's lines of closeness / Time spent in flow / Attitude toward work / Daangn's 4th anniversary",
        category: "essay",
        date: "2025.12.01.",
        thumbnail: article4MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 12,
        blogPage: "/book2",
        title: "우리가 빛의 속도로 갈 수 없다면",
        titleEn: "If We Cannot Travel at the Speed of Light",
        description: "가능성에 집중하기보다 중요한 가치에 집착하기",
        descriptionEn: "Holding on to what matters rather than chasing possibility",
        category: "book report",
        date: "2025.09.01.",
        locked: false,
        year: "2025"
      },
      {
        id: 1,
        blogPage: "/Article3",
        title: "25.09. 회고",
        titleEn: "25.09. Review",
        description: "영월 / 인트리그미션 게임 / 행복하게 사는 것 / 대도시의 사랑법",
        descriptionEn: "Yeongwol trip / The Intrigue Mission game / Living happily / Love in the Big City",
        category: "essay",
        date: "2025.10.01.",
        thumbnail: article3MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 2,
        blogPage: "/Article2",
        title: "25.08. 회고",
        titleEn: "25.08. Review",
        description: "기회가 주어진다면 하고 싶은거 다 해보기 | 함께 살아가기 | 우리가 빛의 속도로 갈 수 없다면 | 건강하게 스트레스에서 회복하기",
        descriptionEn: "Trying everything I want if given the chance | Living alongside others | If We Cannot Travel at the Speed of Light | Recovering from stress in a healthy way",
        category: "essay",
        date: "2025.09.01.",
        thumbnail: article2MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 3,
        blogPage: "/Article1",
        title: "25.07. 회고",
        titleEn: "25.07. Review",
        description: "우연스럽게 생긴 새로운 인연  /  팀 이동  /  블루베리잼 만들기  /  목표없이 놀기  /  요즘 잘 쓰고 있는 앱  /  제로섬 게임  /  능력주의와 운에 대해서",
        descriptionEn: "Unexpected new connections / Switching teams / Making blueberry jam / Playing without a goal / Apps I'm loving lately / Zero-sum games / On meritocracy and luck",
        category: "essay",
        date: "2025.08.01.",
        thumbnail: article1MainImage,
        locked: true,
        year: "2025"
      },
      {
        id: 4,
        blogPage: "/creative1",
        title: "2024 당근 광고실 송년회",
        titleEn: "2024 Daangn Ads Team Year-end Party",
        description: "송년회 기록",
        descriptionEn: "Notes from the year-end party",
        category: "creative",
        date: "2024.12.18.",
        thumbnail: creative1Thumbnail,
        locked: false,
        year: "2024"
      },
      {
        id: 6,
        blogPage: "/creative2",
        title: "2024 당근 광고실 하반기 레크레이션",
        titleEn: "2024 Daangn Ads Team H2 Recreation",
        description: "플레이샵 게임",
        descriptionEn: "Playshop games",
        category: "creative",
        date: "2024.11.07.",
        thumbnail: creative2Thumbnail,
        locked: false,
        year: "2024"
      }
      
    ];

    switch (activeFilter) {
      case 1: // All
        return allContent;
      case 2: // Creative
        return allContent.filter(item => item.category === 'creative');
      case 3: // Book Report
        return allContent.filter(item => item.category === 'book report');
      case 4: // Essay
        return allContent.filter(item => item.category === 'essay');
      case 5: // 2026
        return allContent.filter(item => item.year === '2026');
      case 6: // 2025
        return allContent.filter(item => item.year === '2025');
      case 7: // 2024
        return allContent.filter(item => item.year === '2024');
      default:
        return allContent;
    }
  };

  const filteredContent = getFilteredContent();

  return (
    <div>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav}/>
      <div className='pageTitle'>Life</div>  
      <ActivitiesChipFilter activeFilter={activeFilter} setActiveFilter={handleFilterChange}/>
      <div className='blogContentslist'>
        {filteredContent.map((item, index) => (
          <React.Fragment key={item.id}>
            <div className='contents fadeInUp'>
              <BlogContent
                blogPage={item.blogPage}
                title={item.title}
                titleEn={item.titleEn}
                description={item.description}
                descriptionEn={item.descriptionEn}
                category={item.category}
                categoryEn={item.categoryEn}
                date={item.date}
                thumbnail={item.thumbnail}
                locked={item.locked}
                showNewBadge={getActivityShowNewBadge(item)}
              />
            </div>
            {index < filteredContent.length - 1 && (
              <Divider className='divider2 fadeIn'/>
            )}
          </React.Fragment>
        ))}
      </div>
      <Footer/>
      <LifeTodoToggle />
    </div>
  )
}

export default Activities;

